import React, { useContext, useState, useEffect, useRef } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import { seccionSeccionesPadreStyle, seccionTituloStyle, seccionComentariosStyle, seccionAntSigStyle } from './../styles/general';
import conexion from '../contenidos/conexionContenidos';
import SeccionesContext from './../context/seccionesContext';
import { extraerTituloCompuesto, getSeccionByCodigo, getSeccionesAntAndSig } from '../utils/generales';
import { addComentario, addLike, deleteLike, deleteComentario, getComentariosOfSeccion, updateNombreUsuario } from '../services/dbService';
import UsuarioContext from './../context/usuarioContext';

import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import AntSig from './antSig';

function Seccion() {

    const { cod } = useParams();
    const { secciones, seccionesContenido, onAddLikeSeccion, onRemoveLikeSeccion } = useContext(SeccionesContext);
    const { usuario, onCambioNombreUsuario } = useContext(UsuarioContext);

    const refNombre = useRef(null)
    const refComentarios = useRef(null)
    const refLike = useRef(null)
    
    const [comentarios, setComentarios] = useState(null);
    const [comentario, setComentario] = useState('');
    const [nombre, setNombre] = useState('');
    const [primeroResaltado, setPrimeroResaltado] = useState(false);
    const [procesandoLike, setProcesandoLike] = useState(false);

    const notReady = !secciones || secciones.length < 1;

    const { seccion, tituloCompuesto } = getSeccionByCodigo(secciones, cod);
    const { seccionesPadre, titulo } = extraerTituloCompuesto(tituloCompuesto);
    const { seccionContenidoAnt, seccionContenidoSig } = getSeccionesAntAndSig(seccionesContenido, cod);

    const liked = seccion?.likes && usuario && (seccion.likes.find(x => x === usuario._id) ? true : false);
    const numLikes = seccion?.likes ? seccion.likes.length : 0;

    useEffect(() => {
        // document.title = "Nicolas Barajas" + (seccion ? " - " + seccion.titulo : "" );
        setComentarios(null);
        async function auxGetComentarios() {
            const auxComentarios = await getComentariosOfSeccion(seccion?._id);
            if (auxComentarios){
                setComentarios(auxComentarios);
            }
        }
        auxGetComentarios()
        document.documentElement.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }, [seccion])

    useEffect(() => {
        if (comentarios)
        {
            const hash = window.location.hash;
            if (hash) {
              const element = document.getElementById(hash.substring(1));
              if (element) {
                element.scrollIntoView();
              }
            }
        }
    }, [comentarios]);

    if (notReady){
        return <div className='avisoProcesando blink20'>Cargando...</div>;
    }

    async function handleClickNuevoComentario(){
        let nombreAux = nombre;
        if (!nombre && refNombre.current.defaultValue){
            nombreAux = refNombre.current.defaultValue;
            setNombre(nombreAux);
        }
        if (nombreAux.length < 3){            
            alert("Ingresa tu nombre (mínimo 3 caracteres)");
        } else if (comentario.length < 3) {
            alert("Ingresa un comentario válido (mínimo 3 caracteres)");
        } else {
            let mensajeAgregarComentario = '';
            if (nombreAux !== usuario.nombre){
                onCambioNombreUsuario(nombreAux);
                const usuarioActualizado = await updateNombreUsuario(usuario._id, nombreAux);
                if (!usuarioActualizado){
                    onCambioNombreUsuario(usuario.nombre);
                    mensajeAgregarComentario = "Se presentó un error al intentar guardar tu nombre.";
                }
            }
            if (mensajeAgregarComentario === ''){
                const comentarioOrig = comentario;
                const comentariosOrig = comentarios;

                const comentarioAgregar = {
                    idUsuario: usuario._id,
                    texto: comentario,
                    nombreUsuario: usuario.nombre
                }
                setComentario('');
                setComentarios([comentarioAgregar, ...comentarios])
                // refComentarios.current.scrollIntoView()
                setPrimeroResaltado(true);

                const comentarioAgregado = await addComentario(seccion._id, usuario._id, comentario);

                if (comentarioAgregado){
                    let comentariosAux = [{...comentarioAgregado, nombreUsuario: usuario.nombre}, ...comentariosOrig];
                    if (nombreAux !== usuario.nombre){
                        comentariosAux = comentariosAux.map(x => {
                            if (x.idUsuario === usuario._id){
                                return {...x, nombreUsuario: nombreAux};
                            } else {
                                return {...x};
                            }
                        });
                    }
                    setComentarios(comentariosAux);
                    refComentarios.current.scrollIntoView()
                } else {
                    setComentario(comentarioOrig);
                    setComentarios(comentariosOrig);
                    setPrimeroResaltado(false);
                    mensajeAgregarComentario = "Error al guardar el comentario";
                }
            }
            if (mensajeAgregarComentario.length > 0){
                alert(mensajeAgregarComentario);
            }
        }
    }

    function handleChangeComentario(e){
        setComentario(e.target.value);
    }

    function handleChangeNombre(e){
        setNombre(e.target.value);
    }

    async function onClickBorrarComentario(idComentario){
        const resp = window.confirm('¿Deseas borrar tu comentario?');
        if (resp){
            const comentariosOrig = comentarios;
            const comentariosAux = comentarios.filter(x => x._id !== idComentario);
            setComentarios(comentariosAux);
            const borrado = await deleteComentario(seccion._id, idComentario);
            if (borrado){                
                setPrimeroResaltado(false);
            } else {
                setComentarios(comentariosOrig);
                handleMouseLinkBorrar(idComentario, false);
                alert("Error al borrar el comentario");
            }
        }
    }

    function handleMouseLinkBorrar(idComentario, resaltar){
        const comentariosAux = [...comentarios];
        const comentarioCambiar = comentariosAux.find(x => x._id === idComentario);
        comentarioCambiar.resaltado = resaltar;
        setComentarios(comentariosAux);
    }

    async function handleLikeClick(){
        if (liked) {
            onRemoveLikeSeccion(seccion, usuario._id);
            setProcesandoLike(true);
            const likeFueRemovido = await deleteLike(seccion._id, usuario._id);
            if (!likeFueRemovido){
                onAddLikeSeccion(seccion, usuario._id);
                alert("Error al remover tu like");
            }
            setProcesandoLike(false);
        } else {
            onAddLikeSeccion(seccion, usuario._id);
            setProcesandoLike(true);
            const likeFueAgregado = await addLike(seccion._id, usuario._id);
            if (!likeFueAgregado){
                onRemoveLikeSeccion(seccion, usuario._id);
                alert("Error al agregar tu like");
            }
            setProcesandoLike(false);
        }
    }

    let classLike = (procesandoLike ? "blink08 arrowLinkProcesando " : "arrowLink ") + "fa fa-heart" +  (liked ? "" : "-o");

    if (!seccion) return <Navigate to="/inicio" replace />;

    return (
        <div>
            <Helmet>
                <meta property="og:title" content={seccion ? seccion.titulo : ""} />
                <meta property="og:url" content={`https://nicolasbarajas.netlify.app/${cod}`} />
            </Helmet>
            <div style={seccionSeccionesPadreStyle}>
                {seccionesPadre}
            </div>
            <div style={seccionTituloStyle}>
                {titulo}
            </div>
            {conexion[cod]}
            <div style={{textAlign: "right", fontSize: "20px"}}>
                {numLikes + '\u00A0\u00A0'}
                <i ref={refLike} style={{fontSize: "20px"}} title={procesandoLike ? 'Procesando' : (liked ? 'No me gusta' : 'Me gusta')} className={classLike} aria-hidden="true" onClick={procesandoLike ? null : handleLikeClick}></i>
            </div>
            <div style={seccionAntSigStyle}>
                <table style={{width: "100%"}}>                    
                    <colgroup>
                        <col style={{width: "50%"}}/>
                        <col style={{width: "50%"}}/>
                    </colgroup>
                    <tbody>
                        <tr>
                            <td>
                                <AntSig seccionContenido={seccionContenidoAnt} ant={true}></AntSig>
                            </td>
                            <td>
                                <AntSig seccionContenido={seccionContenidoSig} ant={false}></AntSig>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style={seccionComentariosStyle}>
                <div ref={refComentarios} style={{ paddingBottom: "10px" }}>
                    <b>Comentarios:</b>
                </div>
                <Form.Control as="textarea" value={comentario} placeholder='Ingresa acá un comentario nuevo' style={{width: "100%", height: "100px"}} maxLength={500} onChange={handleChangeComentario} />
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px', width: '100%' }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                        <InputGroup className="mb-3" style={{paddingTop: "10px"}}>
                            <InputGroup.Text>Tu nombre:</InputGroup.Text>
                            <Form.Control ref={refNombre} type="text" defaultValue={usuario?.nombre ? usuario.nombre : ""} style={{width: "50%"}} onChange={handleChangeNombre} maxLength={30}/>
                        </InputGroup>
                    </div>
                    <Button variant="secondary" onClick={handleClickNuevoComentario} style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>Agregar</Button>
                </div>
                <div className={!comentarios ? 'blink20' : ""} style={{textAlign: "center", paddingBottom: "10px"}}>
                    {
                        !comentarios ?
                        "Cargando comentarios..."
                        :
                        `${comentarios.length} comentario${comentarios.length !== 1 ? "s" : ""}${comentarios.length > 0 ? ":" : ""}`
                    }
                </div>
                {
                    !comentarios ? null :
                    comentarios.map((x, i) => {
                        let colorBorde = "#e6e6e6";
                        if (i === 0 && primeroResaltado){
                            colorBorde = "green";
                        }
                        if (x.resaltado){
                            colorBorde = "red";
                        }
                        return(
                            <div key={i + "div"} style={{border: "solid " + colorBorde + " thin", borderRadius: "2px", padding: "8px", marginBottom: "10px"}}>
                                <span key={i + "span"} style={{fontWeight: "bold", fontSize: "15px"}}>{x.nombreUsuario}:</span>
                                <br key={i + "br"}/>
                                <p key={i + "p"} style={{marginBottom: 0, fontSize: "15px"}}>{x.texto}</p>
                                { x._id && x.idUsuario === usuario._id ? 
                                    <span 
                                        className='linkBorrar'
                                        style={{fontSize: "15px"}}
                                        onClick={ () => onClickBorrarComentario(x._id)}
                                        onMouseEnter={ () => handleMouseLinkBorrar(x._id, true)}
                                        onMouseLeave={ () => handleMouseLinkBorrar(x._id, false)}
                                        >Borrar</span>
                                    : null
                                }
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
}

export default Seccion;